var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { shouldCacheResponse } from '../util/cache-predicate';
import { Header } from '../util/headers';
import { updateCache } from '../util/update-cache';
var CacheResponseInterceptor = /** @class */ (function () {
    function CacheResponseInterceptor(axios) {
        var _this = this;
        this.axios = axios;
        this.use = function () {
            _this.axios.interceptors.response.use(_this.onFulfilled);
        };
        this.onFulfilled = function (axiosResponse) { return __awaiter(_this, void 0, void 0, function () {
            var response, cacheConfig, cache, ttl, expirationTime, data, newCache, deferred;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        response = this.cachedResponse(axiosResponse);
                        // Response is already cached
                        if (response.cached) {
                            return [2 /*return*/, response];
                        }
                        // Skip cache
                        // either false or weird behavior, config.cache should always exists, from global config merge at least
                        if (!response.config.cache) {
                            return [2 /*return*/, __assign(__assign({}, response), { cached: false })];
                        }
                        cacheConfig = response.config.cache;
                        return [4 /*yield*/, this.axios.storage.get(response.id)];
                    case 1:
                        cache = _a.sent();
                        if (
                        // If the request interceptor had a problem
                        cache.state === 'stale' ||
                            cache.state === 'empty' ||
                            // Should not hit here because of previous response.cached check
                            cache.state === 'cached') {
                            return [2 /*return*/, response];
                        }
                        if (!
                        // For 'loading' values (post stale), this check was already run in the past.
                        (!cache.data &&
                            !shouldCacheResponse(response, cacheConfig))) 
                        // For 'loading' values (post stale), this check was already run in the past.
                        return [3 /*break*/, 3];
                        return [4 /*yield*/, this.rejectResponse(response.id)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, response];
                    case 3:
                        // avoid remnant headers from remote server to break implementation
                        delete response.headers[Header.XAxiosCacheEtag];
                        delete response.headers[Header.XAxiosCacheLastModified];
                        if (cacheConfig.etag && cacheConfig.etag !== true) {
                            response.headers[Header.XAxiosCacheEtag] = cacheConfig.etag;
                        }
                        if (cacheConfig.modifiedSince) {
                            response.headers[Header.XAxiosCacheLastModified] =
                                cacheConfig.modifiedSince === true
                                    ? 'use-cache-timestamp'
                                    : cacheConfig.modifiedSince.toUTCString();
                        }
                        ttl = cacheConfig.ttl || -1;
                        if (!(cacheConfig === null || cacheConfig === void 0 ? void 0 : cacheConfig.interpretHeader)) return [3 /*break*/, 6];
                        expirationTime = this.axios.headerInterpreter(response.headers);
                        if (!(expirationTime === false)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.rejectResponse(response.id)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, response];
                    case 5:
                        ttl = expirationTime || expirationTime === 0 ? expirationTime : ttl;
                        _a.label = 6;
                    case 6:
                        data = CacheResponseInterceptor.setupCacheData(response, cache.data);
                        newCache = {
                            state: 'cached',
                            ttl: ttl,
                            createdAt: Date.now(),
                            data: data
                        };
                        // Update other entries before updating himself
                        if (cacheConfig === null || cacheConfig === void 0 ? void 0 : cacheConfig.update) {
                            updateCache(this.axios.storage, response.data, cacheConfig.update);
                        }
                        deferred = this.axios.waiting[response.id];
                        // Resolve all other requests waiting for this response
                        return [4 /*yield*/, (deferred === null || deferred === void 0 ? void 0 : deferred.resolve(newCache.data))];
                    case 7:
                        // Resolve all other requests waiting for this response
                        _a.sent();
                        delete this.axios.waiting[response.id];
                        // Define this key as cache on the storage
                        return [4 /*yield*/, this.axios.storage.set(response.id, newCache)];
                    case 8:
                        // Define this key as cache on the storage
                        _a.sent();
                        // Return the response with cached as false, because it was not cached at all
                        return [2 /*return*/, response];
                }
            });
        }); };
        /** Rejects cache for this response. Also update the waiting list for this key by rejecting it. */
        this.rejectResponse = function (key) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: 
                    // Update the cache to empty to prevent infinite loading state
                    return [4 /*yield*/, this.axios.storage.remove(key)];
                    case 1:
                        // Update the cache to empty to prevent infinite loading state
                        _b.sent();
                        // Reject the deferred if present
                        (_a = this.axios.waiting[key]) === null || _a === void 0 ? void 0 : _a.reject(null);
                        delete this.axios.waiting[key];
                        return [2 /*return*/];
                }
            });
        }); };
        this.cachedResponse = function (response) {
            return __assign({ id: _this.axios.generateKey(response.config), 
                // The request interceptor response.cache will return true or undefined. And true only when the response was cached.
                cached: response.cached || false }, response);
        };
    }
    /**
     * Creates the new date to the cache by the provided response. Also handles possible 304
     * Not Modified by updating response properties.
     */
    CacheResponseInterceptor.setupCacheData = function (response, cache) {
        if (response.status === 304 && cache) {
            // Set the cache information into the response object
            response.cached = true;
            response.data = cache.data;
            response.status = cache.status;
            response.statusText = cache.statusText;
            // Update possible new headers
            response.headers = __assign(__assign({}, cache.headers), response.headers);
            // return the old cache
            return cache;
        }
        // New Response
        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        };
    };
    return CacheResponseInterceptor;
}());
export { CacheResponseInterceptor };
